import * as React from "react";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../utils/Helpers";
import { FocusableItemDirectionEnum } from "../../utils/Focus";
export var PlayerDubbingList = function (_a) {
    var language = _a.language, popup = _a.popup, audioTracks = _a.audioTracks, onSetDubbing = _a.onSetDubbing, onBackPress = _a.onBackPress, audioListRef = _a.audioListRef;
    var t = useTranslation().t;
    return (React.createElement("div", { className: "dubbing-list", ref: audioListRef, tabIndex: 0 },
        React.createElement("p", null, language ? language.toUpperCase() : null),
        React.createElement("span", { className: "popup", style: "display: " + (popup === "dubbing" ? "block" : "none") },
            React.createElement("ul", { id: "dubbing-list", "data-direction": "1" },
                React.createElement("li", { className: "popup-title" }, t("player.dub_language")),
                audioTracks &&
                    popup === "dubbing" &&
                    audioTracks.map(function (track, index) { return (React.createElement(PlayerAudioTrackItemView, { key: index, track: track, handleSetDubbing: onSetDubbing, handleBackPress: onBackPress, focusRaw: ["playerPopup", index], active: language === track.lang })); })))));
};
var PlayerAudioTrackItemView = function (_a) {
    var focusRaw = _a.focusRaw, track = _a.track, handleSetDubbing = _a.handleSetDubbing, handleBackPress = _a.handleBackPress, active = _a.active;
    var t = useTranslation().t;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        direction: FocusableItemDirectionEnum.Vertical,
        onKeyDown: function () { return handleSetDubbing(track); },
        onKeyBack: function () { return handleBackPress(); },
    });
    return (React.createElement("li", { ref: ref, tabIndex: 0, className: active ? "active" : "" }, t("player.languages." + track.lang)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/player/PlayerDubbingList.tsx
// module id = 198
// module chunks = 1